import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { BASE_URL } from '../../config/constants';
import { useTranslation } from 'react-i18next';
function AddLessons() {
	const { t } = useTranslation();
	const [courses, setCourses] = useState([]);
	const [lessons, setLessons] = useState([]);
	const [fileUploading, setFileUploading] = useState(false);
	const [lessonId, setLessonId] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const [formData, setFormData] = useState({
		title: '',
		description: '',
		courseId: '',
		index: '',
		fileId: '',
		video: {
			URL: '',
		},
		question: {
			question: '',
			type: 'MCQ',
			options: ['', '', '', ''],
			correctAnswer: 1,
		},
	});
	const baseUrl = BASE_URL; // Fetch courses and lessons on component mount
	useEffect(() => {
		const getCourses = async () => {
			try {
				const response = await fetch(`${baseUrl}/api/v1/courses`, {
					headers: {
						Authorization: `Bearer ${Cookies.get('token')}`,
					},
				});

				const data = await response.json();
				if (response.ok) {
					setCourses(data);
				} else {
					console.error('Error fetching courses:', data);
				}
			} catch (error) {
				console.error('Error fetching courses:', error);
			}
		};

		const getLessons = async () => {
			try {
				const response = await fetch(`${baseUrl}/api/v1/lessons`, {
					headers: {
						Authorization: `Bearer ${Cookies.get('token')}`,
					},
				});

				const data = await response.json();
				if (response.ok) {
					setLessons(data);
				} else {
					console.error('Error fetching lessons:', data);
				}
			} catch (error) {
				console.error('Error fetching lessons:', error);
			}
		};

		getCourses();
		getLessons();
	}, []);

	const [file, setFile] = useState(null);

	const handleFileChange = (e) => {
		setFile(e.target.files[0]);
	};

	const handleInputsValue = (event) => {
		const { name, value } = event.target;
		if (name === 'videoUrl') {
			setFormData({
				...formData,
				video: { URL: value },
			});
		} else {
			setFormData({
				...formData,
				[name]: value,
			});
		}
	};

	const handleSubmitForm = async (e) => {
		e.preventDefault();

		if (!file) {
			alert('Please select a file before submitting.');
			return;
		}

		setFileUploading(true);

		try {
			const formDataForFile = new FormData();
			formDataForFile.append('file', file);

			const fileResponse = await fetch(`${baseUrl}/api/v1/files/upload`, {
				method: 'POST',
				headers: {
					Authorization: `Bearer ${Cookies.get('token')}`,
				},
				body: formDataForFile,
			});

			const fileData = await fileResponse.json();

			if (!fileResponse.ok) {
				console.error('Error uploading file:', fileData.error);
				alert('File upload failed. Please try again.');
				return;
			}

			const fileId = fileData.file.id;
			setFormData((prev) => ({
				...prev,
				fileId,
			}));

			const formResponse = await fetch(`${baseUrl}/api/v1/lessons`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookies.get('token')}`,
				},
				body: JSON.stringify({ ...formData, fileId }),
			});

			console.log(JSON.stringify({ ...formData, fileId }));
			if (formResponse.ok) {
				console.log('Lesson created successfully');
				alert('Lesson created successfully');
				setFormData({
					title: '',
					description: '',
					courseId: '',
					index: '',
					fileId: '',
					video: {
						URL: '',
					},
					question: {
						question: '',
						type: 'MCQ',
						options: ['', '', '', ''],
						correctAnswer: 1,
					},
				});
				setFile(null);
				fetchLessons();
			} else {
				const formDataResponse = await formResponse.json();
				console.error('Error creating lesson:', formDataResponse.error);
				alert('Lesson creation failed. Please try again.');
			}
		} catch (error) {
			console.error('Error:', error);
			alert('An error occurred. Please try again.');
		} finally {
			setFileUploading(false);
		}
	};

	const handleEditLesson = async (event) => {
		event.preventDefault();
		try {
			const response = await fetch(`${baseUrl}/api/v1/lessons/${lessonId}`, {
				method: 'PATCH',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookies.get('token')}`,
				},
				body: JSON.stringify(formData),
			});

			if (response.ok) {
				alert('Lesson updated successfully');
				setFormData({
					title: '',
					description: '',
					courseId: '',
					index: '',
					fileId: '',
					video: {
						URL: '',
					},
					question: {
						question: '',
						type: 'MCQ',
						options: ['', '', '', ''],
						correctAnswer: 1,
					},
				});
				setFile(null);
				setIsEditing(false);
				fetchLessons();
			} else {
				alert('Error updating lesson');
			}
		} catch (error) {
			alert('Error updating lesson');
		}
	};

	const handleDeleteLesson = async (event) => {
		event.preventDefault();
		if (!lessonId) {
			alert('Please select a lesson to delete');
			return;
		}

		try {
			const response = await fetch(`${baseUrl}/api/v1/lessons/${lessonId}`, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookies.get('token')}`,
				},
			});

			if (response.ok) {
				alert('Lesson deleted successfully');
				setLessonId('');
				setFormData({
					title: '',
					description: '',
					courseId: '',
					index: '',
					fileId: '',
					video: {
						URL: '',
					},
					question: {
						question: '',
						type: 'MCQ',
						options: ['', '', '', ''],
						correctAnswer: 1,
					},
				});
				fetchLessons();
			} else {
				alert('Error deleting lesson');
			}
		} catch (error) {
			alert('Error deleting lesson');
		}
	};

	const fetchLessons = async () => {
		try {
			const response = await fetch(`${baseUrl}/api/v1/lessons`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookies.get('token')}`,
				},
			});
			if (response.ok) {
				const data = await response.json();
				setLessons(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleGetLessonData = async (event) => {
		const selectedLessonId = event.target.value;
		setLessonId(selectedLessonId);

		try {
			const response = await fetch(
				`${baseUrl}/api/v1/lessons/${selectedLessonId}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookies.get('token')}`,
					},
				}
			);

			if (response.ok) {
				const data = await response.json();
				setFormData({
					title: data.title,
					description: data.description,
					courseId: data.id,
					index: data.index,
					fileId: data.fileId,
					video: {
						URL: data.video.URL,
					},
					question: data.question,
				});
				setIsEditing(true);
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<div className='flex flex-wrap gap-4 items-start justify-center py-8 container mt-36'>
			<form
				className='w-full fileForm bg-white p-6 rounded-lg shadow-md border-2 border-main flex justify-center items-center flex-wrap gap-3'
				onSubmit={isEditing ? handleEditLesson : handleSubmitForm}>
				<h2 className='text-2xl text-main font-bold mb-4 w-full'>
					{isEditing ? 'Edit Lesson' : 'Add Lesson'}
				</h2>
				{/* Title Input */}
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('title')}</label>
					<input
						type='text'
						name='title'
						value={formData.title}
						onChange={handleInputsValue}
						placeholder='Lesson title'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>

				{/* Description Input */}
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('description')}</label>
					<input
						type='text'
						name='description'
						value={formData.description}
						onChange={handleInputsValue}
						placeholder='Lesson description'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>

				{/* Index Input */}
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('index')}</label>
					<input
						type='number'
						name='index'
						value={Number(formData.index)}
						onChange={(e) =>
							handleInputsValue({
								target: { name: 'index', value: Number(e.target.value) },
							})
						}
						placeholder='Lesson index'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>

				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('courses')}</label>
					<select
						name='courseId'
						value={Number(formData.courseId)}
						onChange={(e) =>
							handleInputsValue({
								target: { name: 'courseId', value: Number(e.target.value) },
							})
						}
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'>
						<option value=''> {t('selectCourse')}</option>
						{courses.length > 0 ? (
							courses.map((course) => (
								<option
									key={course.id}
									value={course.id}>
									{course.name}
								</option>
							))
						) : (
							<option value=''>No courses available </option>
						)}
					</select>
				</div>

				{/* Video URL Input */}
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('videoURL')}</label>
					<input
						type='text'
						name='videoUrl'
						value={formData.video.URL}
						onChange={handleInputsValue}
						placeholder='Video URL'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>

				{/* Question Input */}
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('question')}</label>
					<input
						type='text'
						name='question'
						value={formData.question.question}
						onChange={(e) =>
							setFormData({
								...formData,
								question: { ...formData.question, question: e.target.value },
							})
						}
						placeholder='Question'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>

				{/* Options Input */}
				<div className='flex flex-col flex-grow gap-2'>
					<label className='text-main'> {t('question')}</label>
					{formData.question.options.map((option, index) => (
						<input
							key={index}
							type='text'
							value={option}
							onChange={(e) => {
								const newOptions = [...formData.question.options];
								newOptions[index] = e.target.value;
								setFormData({
									...formData,
									question: { ...formData.question, options: newOptions },
								});
							}}
							placeholder={`Option ${index + 1}`}
							className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
						/>
					))}
				</div>

				{/* Correct Answer Input */}
				<div className='flex flex-col flex-grow'>
					<label className='text-main'> {t('correctAnswer')}</label>
					<input
						type='number'
						name='correctAnswer'
						value={formData.question.correctAnswer}
						onChange={(e) =>
							setFormData({
								...formData,
								question: {
									...formData.question,
									correctAnswer: parseInt(e.target.value),
								},
							})
						}
						placeholder='Correct Answer Index'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>

				{/* File Upload */}
				<div className='flex flex-col flex-grow w-full'>
					<label className='text-main'> {t('uploadFile')}</label>
					<input
						type='file'
						onChange={handleFileChange}
						accept='.doc,.docx,.pdf,.ppt,.pptx'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
					{fileUploading && (
						<span className='text-main'> {t('uploadFile')}</span>
					)}
				</div>

				{/* Submit Button */}
				<div className='flex flex-col flex-grow w-full'>
					<button
						type='submit'
						className='bg-main text-white p-2 rounded-lg w-full md:w-1/2 self-start'
						disabled={fileUploading}>
						{isEditing ? 'Update Lesson' : 'Add Lesson'}
					</button>
				</div>
			</form>

			<form className='bg-white p-6 rounded-lg shadow-md w-full  border-2 border-main flex flex-wrap gap-3'>
				<h2 className='text-main text-2xl font-bold'> {t('editLesson')}</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={lessonId}
					onChange={handleGetLessonData}>
					<option value=''> {t('selectEditLesson')}</option>
					{lessons.map((lesson) => (
						<option
							key={lesson.id}
							value={lesson.id}>
							{lesson.title}
						</option>
					))}
				</select>
			</form>

			<form
				className='bg-white p-6 rounded-lg shadow-md w-full  border-2 border-red-600 flex flex-wrap gap-3'
				onSubmit={handleDeleteLesson}>
				<h2 className='text-red-600 text-2xl font-bold'>
					{' '}
					{t('deleteLesson')}
				</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={lessonId}
					onChange={handleGetLessonData}>
					<option value=''> {t('selectDeleteLesson')}</option>
					{lessons.map((lesson) => (
						<option
							key={lesson.id}
							value={lesson.id}>
							{lesson.title}
						</option>
					))}
				</select>
				<button
					type='submit'
					className='w-full bg-red-600 text-white py-2 px-4 rounded-lg md:w-1/3'>
					{t('deleteLesson')}
				</button>
			</form>
		</div>
	);
}

export default AddLessons;
